import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SupplymaterialService {

  // private apiUrl = "http://localhost:3003/api";
  apiUrl = "https://lexipackghana.com:3003/api";

  constructor(private http: HttpClient) { }

  addMaterial(data:any){
    return this.http.post(this.apiUrl+'/addMaterial',data);
  }
  getMaterial(){
    return this.http.get(this.apiUrl+'/materialList');
  }
  getMaterialById(id: string) {
    return this.http.get(this.apiUrl + '/material/' + id);
  }
  updateMaterial(id: string, data: any) {
    return this.http.put(this.apiUrl + '/material/' + id, data);
  }
}
